import { Zip } from "@pdfking/tfunc"

/**
 * Zips multiple iterables into array of tuples.
 *
 * @param args - Iterables to zip
 * @returns Array of tuples
 *
 * @example
 * ```ts
 * import { zip } from "@pdfking/rfunc"
 *
 * zip([1, 2], [3, 4]) // [[1, 3], [2, 4]]
 * zip([1, 2], [3, 4], [5, 6]) // [[1, 3, 5], [2, 4, 6]]
 * ```
 */
export const zip = (...args) => [...Zip(...args)]
